import { LoadingProps } from "./types";

import "./styles.scss";

export default function Loading({ type = "primary", size = 24 }: LoadingProps) {
	const IcoLoadingNeutral = `${process.env.PUBLIC_URL}/images/loading/ico-loading-neutral.png`;
	const IcoLoadingPrimary = `${process.env.PUBLIC_URL}/images/loading/ico-loading-primary.png`;
	const IcoLoadingSecundary = `${process.env.PUBLIC_URL}/images/loading/ico-loading-secondary.png`;

	let image;

	switch (type) {
		case "primary":
			image = IcoLoadingPrimary;
			break;
		case "secondary":
			image = IcoLoadingSecundary;
			break;
		default:
			image = IcoLoadingNeutral;
			break;
	}

	return (
		<div className="container-loading">
			<img
				className="ico-loading"
				src={image}
				style={{ height: size, width: size }}
				alt="Carregando..."
			/>
		</div>
	);
}
